<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账户名：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">密码：</span>
        </div>
        <a @click="dialogVisible = true" style="color:#00a0e6;">修改密码</a>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">确认密码：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.confirmPassword" type="password" size="small" style="width: 280px" />-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人姓名：</span>
        </div>
        <el-select v-model="personCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="mini" style="width: 280px">
          <el-option
            v-for="item in actualList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">联系人手机：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" disabled />
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<span class="line-text">联系人邮箱：</span>-->
        <!--</div>-->
        <!--<el-input v-model="formData.email" size="small" style="width: 280px" />-->
      <!--</div>-->
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">账号归属：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.enterpriseCode" placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in enterpriseList"-->
            <!--:key="item.code"-->
            <!--:label="item.enterpriseName"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">上级账号：</span>
        </div>
        <el-select v-model="formData.parentCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in accountList"
            :key="item.code"
            :label="item._labelName"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">楼栋权限：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.buildingCodes" multiple placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in buildingList"-->
            <!--:key="item.code"-->
            <!--:label="item.name"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联角色：</span>
        </div>
        <el-select v-model="formData.roleCode" placeholder="请选择" size="mini" style="width: 280px">
          <el-option
            v-for="item in roleList"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!--<div class="form-line">-->
        <!--<div class="textBox">-->
          <!--<b class="red">*</b>-->
          <!--<span class="line-text">关联住户：</span>-->
        <!--</div>-->
        <!--<el-select v-model="formData.enterpriseCode" placeholder="请选择" size="mini" style="width: 280px">-->
          <!--<el-option-->
            <!--v-for="item in enterpriseList"-->
            <!--:key="item.code"-->
            <!--:label="item.enterpriseName"-->
            <!--:value="item.code">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</div>-->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否可复用：</span>
        </div>
        <el-switch
          v-model="multiplexing"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="35%">
      <div class="dialogLine">
        <div><b style="color: red">*</b>旧密码</div>
        <el-input type="password" v-model="password" size="small"/>
      </div>
      <div class="dialogLine">
        <div><b style="color: red">*</b>新密码</div>
        <el-input type="password" v-model="newPassword" size="small"/>
      </div>
      <div class="dialogLine">
        <div><b style="color: red">*</b>确认密码</div>
        <el-input type="password" v-model="newPasswordAgain" size="small"/>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/Account";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "account-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "资源中心",
          name: "yq-information"
        },
        {
          value: "子账号管理"
        }
      ],
      mainTitle: "修改账户",
      subheading: "修改访问平台的账户，关联访问权限",
      roleList: [],
      multiplexing: false,
      dialogVisible: false,
      enterpriseList: [],
      buildingList: [],
      accountList: [],
      actualList: [],
      personCode: "",
      formData: {
        name: "",
        personCode: "",
        actualName: "",
        password: "",
        confirmPassword: "",
        phone: "",
        email: "",
        // buildingCodes: '',
        parentCode: "",
        roleCode: "",
        roleName: "",
        enterpriseCode: "",
        enterpriseName: "",
        isReuse: ""
      },
      password: "",
      newPassword: "",
      newPasswordAgain: ""
    };
  },
  created() {
    // this.getEnterpriseList()
    this.getRoleList();
    this.getAccountList();
    this.getAccountByCode();
    // this.getResponsiblePerson()
    this.remoteMethod();
    // this.getBuildingList()
  },
  methods: {
    toAccountManagementPage() {
      this.$router.push({
        name: "account-management"
      });
    },
    remoteMethod(query) {
      this.getResponsiblePerson(query);
    },
    // 获取人员列表
    getResponsiblePerson(searchKey) {
      this.$axios
        .post(api.getResponsiblePerson, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.actualList = data;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },
    // 获取楼栋列表
    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.buildingList = data;
          }
        })
        .catch(errorHandler("获取楼栋信息失败"));
    },
    // 获取账户列表
    getAccountList() {
      this.$axios
        .post(api.getAccountList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data.length > 0) {
              data.map(v => {
                v._labelName = `${v.name} / ${v.actualName ? v.actualName : ''}`;
              });
            }
            this.accountList = data;
          }
        })
        .catch(errorHandler("获取账户列表失败"));
    },
    // 获取住户列表
    getEnterpriseList() {
      this.$axios
        .post(api.getEnterpriseList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.enterpriseList = res.data.data;
          }
        })
        .catch(errorHandler("获取住户列表失败"));
    },
    // 获取角色列表
    getRoleList() {
      this.$axios
        .post(api.getRoleList, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.roleList = res.data.data;
          }
        })
        .catch(errorHandler("获取角色列表失败"));
    },
    // 获取单个子账号信息
    getAccountByCode() {
      this.$axios
        .get(`${api.getAccountByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
            this.personCode = this.formData.personCode;
            if (this.formData.isReuse === "1") {
              this.multiplexing = true;
            } else {
              this.multiplexing = false;
            }
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    changePassword() {
      let checkPassword = pattern.password.test(this.newPassword);
      if (!this.newPassword) {
        nError("请输入密码");
        return false;
      } else {
        if (!checkPassword) {
          nError("请输入8至20位无特殊字符的密码");
          return false;
        }
      }
      if (this.newPassword !== this.newPasswordAgain) {
        nError("两次密码不一致");
        return false;
      }
      let name = this.formData.name.toLowerCase();
      let pw = this.password + name;
      let newpw = this.newPassword + name;
      let once = md5(pw) + name;
      let newonce = md5(newpw) + name;
      let pwd;
      let newpwd;
      for (let i = 0; i < 9; i++) {
        pwd = md5(once);
        once = pwd + name;
        newpwd = md5(newonce);
        newonce = newpwd + name;
      }
      this.$axios
        .post(api.changePassword, {
          code: this.formData.code,
          password: pwd,
          newPassword: newpwd
        })
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.password = "";
            this.newPassword = "";
            this.newPasswordAgain = "";
            this.dialogVisible = false;
          }
        })
        .catch(errorHandler("修改失败"));
    },
    confirm() {
      let checkName = pattern.characterInput_24.test(this.formData.name);
      let checkActualName = pattern.characterInput_24.test(
        this.formData.actualName
      );
      let checkPhone = pattern.phone.test(this.formData.phone);
      if (!this.formData.name) {
        nError("请输入账户名");
        return false;
      } else {
        if (!checkName) {
          nError("账户名不允许有特殊字符或空格");
          return false;
        }
      }
      if (!this.formData.actualName) {
        nError("请输入联系人姓名");
        return false;
      } else {
        if (!checkActualName) {
          nError("联系人姓名不允许有特殊字符或空格");
          return false;
        }
      }
      if (!this.formData.phone) {
        nError("请输入联系人手机");
        return false;
      } else {
        if (!checkPhone) {
          nError("联系人手机格式不正确");
          return false;
        }
      }
      if (!this.formData.roleCode) {
        nError("请选择关联角色");
        return false;
      }
      this.roleList.map(v => {
        if (this.formData.roleCode === v.code) {
          this.formData.roleName = v.name;
        }
      });
      // this.enterpriseList.map(v => {
      //   if (this.formData.enterpriseCode === v.code) {
      //     this.formData.enterpriseName = v.enterpriseName
      //   }
      // })
      if (this.multiplexing) {
        this.formData.isReuse = "1";
      } else {
        this.formData.isReuse = "0";
      }
      this.$axios
        .post(api.updateAccount, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toAccountManagementPage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.toAccountManagementPage();
    }
  },
  watch: {
    personCode() {
      this.actualList.map(v => {
        if (v.code === this.personCode) {
          this.formData.personCode = this.personCode;
          this.formData.actualName = v.name;
          this.formData.phone = v.phone;
        }
      });
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: -webkit-baseline-middle;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.dialogLine {
  width: 60%;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.dialogLine div {
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/AccountManagement/AccountModify.vue